import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetClientLargeClaimyClientName = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CLIENT_LARGE_CLAIM_BY_CLIENT_NAME + id,
    token
  );
  return res;
};

export const ImportLargeClaim = (
  clientID,
  ClientName,
  UserId,
  UserName,
  payload
) => {
  const token = localStorage.getItem("token");

  let res = Services.POSTFORMDATA(
    `/api/ACG_ClientLargeClaim/ImportLargeClaimPepm?ClientId=${clientID}&ClientName=${ClientName}&Currentlicense=${UserId}&UserName=${UserName}&UserId=${UserId}`,
    payload,
    token
  );
  return res;
};

// export const ImportLargeClaim = async (
//   clientID,
//   ClientName,
//   UserId,
//   UserName,
//   payload
// ) => {
//   const token = localStorage.getItem("token");
//   const url = `${
//     Url.IMPORT_LARGE_CLAIM + clientID
//   }&ClientName=${ClientName}&Currentlicense=${UserId}&UserName=${UserName}`;

//   let res = await Services.POST(url, payload, token);
//   return res;
// };

export const AddDataToLargeClaim = async (clientID, UserName, boolean, UserId) => {
  const token = localStorage.getItem("token");
  const url = `${
    Url.ADD_CLIENT_LARGE_CLAIM + UserName
  }&clientId=${clientID}&deleteRecord=${boolean}&UserId=${UserId}`;
  let res = await Services.POST(url, "", token);
  return res;
};
